import {Link, useLocation} from "react-router-dom";
import {Fragment, useContext} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";

export default function Breadcrumbs()
{
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const location = useLocation();

    // Don't show breadcrumbs on home page
    if (location.pathname === '/') {
        return null;
    }

    return (<div className="crumbs">
        <div className="container">
            <div className="d-flex align-items-center flex-wrap" style={{gap: '4px 8px'}}>
                <Link to={'/'}>Главная</Link>
                {state.breadcrumbs.map((item, index) => <Fragment key={index}><span>/</span>{item.url ? <Link to={item.url}>{item.name}</Link> : item.name}</Fragment>)}
            </div>
        </div>
    </div>)
}
